<div class="content contentHeight">
  <h1></h1>
  <div class="backgroundWhiteRound table">
    <table>
      <caption></caption>
      <thead>
        <tr>
          <th scope="col" class="jaune"><label [translate]="'hiddenreferences.code'"></label></th>
          <th scope="col" class="jaune"><label [translate]="'hiddenreferences.qualite'"></label></th>
          <th scope="col" class="jaune"><label [translate]="'hiddenreferences.description'"></label></th>
          <th scope="col" class="rouge"><label [translate]="'hiddenreferences.cromax'"></label></th>
          <th scope="col" class="gris"><label [translate]="'hiddenreferences.spieshecker'"></label></th>
          <th scope="col" class="bleu"><label [translate]="'hiddenreferences.standox'"></label></th>
        </tr>
      </thead>
      <tbody>
        <!--<tr>
    <td class="text-center">5302</td>
    <td class="text-center">ADV</td>
    <td class="text-center">Produit non référencé ADV Bleu</td>
    <td class="text-center">AM22</td>
    <td class="text-center">9047</td>
    <td class="text-center">KA677</td>
  </tr>-->
        <tr>
          <td class="text-center">5201</td>
          <td class="text-center">Oxelia H20</td>
          <td class="text-center">Produit non référencé Teinte Noir</td>
          <td class="text-center">1409W</td>
          <td class="text-center">WB809</td>
          <td class="text-center">WB307</td>
        </tr>
        <tr>
          <td class="text-center">5101</td>
          <td class="text-center">IXELLTECH</td>
          <td class="text-center">Produit non référencé Teinte Noir</td>
          <td class="text-center">WB9908</td>
          <td class="text-center">WT1500</td>
          <td class="text-center">MIX 180</td>
        </tr>
        <tr>
          <td class="text-center">5401</td>
          <td class="text-center">TU</td>
          <td class="text-center">Produit non référencé TU Spectraflair</td>
          <td class="text-center">WB1736</td>
          <td class="text-center">WT307</td>
          <td class="text-center">MIX 287</td>
        </tr>
        <tr>
          <td class="text-center">5402</td>
          <td class="text-center">TU</td>
          <td class="text-center">TU Perle bleu effet</td>
          <td class="text-center">WH1726</td>
          <td class="text-center">WT314</td>
          <td class="text-center">MIX 126</td>
        </tr>
      </tbody>
    </table>
    <h3 class="alert">{{'hiddenreferences.alert'|translate}}</h3>
  </div>
</div>
